// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__3uq5V","row":"styles_row__DvO6L"};